import axios, { AxiosInstance } from "axios";

export const createApiClient = (
  token: string,
  timeout?: number
): AxiosInstance => {
  const timeoutSetting = timeout ?? 10000;
  console.log('timeout setting')
  console.log({timeoutSetting})
  return axios.create({
    headers: {
      "Content-Type": "application/json",
      Authtoken: token,
    },
    timeout: timeoutSetting,
  });
};
